"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collectible = void 0;
/**
 * Represents a unique item or asset in a collection.
 */
class Collectible {
    /**
     * Constructs a new Collectible instance.
     * @param {ICollectible} param0 - Object containing the collectible item's properties.
     */
    constructor({ description, name, imageURL, descriptorUri, createdAt, tokenId, collection, owner, creator, }) {
        this.description = description;
        this.name = name;
        this.imageURL = imageURL;
        this.descriptorUri = descriptorUri;
        this.createdAt = createdAt;
        this.tokenId = tokenId;
        this.collection = collection;
        this.owner = owner;
        this.creator = creator;
    }
    /**
     * Decodes the descriptor URI to retrieve metadata.
     * @returns {object | null} The decoded metadata or null if decoding fails.
     */
    decodeDescriptorUri() {
        if (this.descriptorUri.startsWith('data:application/json')) {
            const base64Content = this.descriptorUri.split(',').pop();
            if (base64Content) {
                const decodedBytes = Buffer.from(base64Content, 'base64');
                return JSON.parse(decodedBytes.toString('utf8'));
            }
        }
        return null;
    }
    /**
     * Getter method to retrieve the image URL either directly or from decoded metadata.
     * @returns {string | null} The image URL or null if not available.
     */
    get image() {
        if (this.imageURL) {
            return this.imageURL;
        }
        else {
            const decodedMetadata = this.decodeDescriptorUri();
            if (decodedMetadata && 'image' in decodedMetadata) {
                return decodedMetadata['image'];
            }
        }
        return null;
    }
    /**
     * Creates a Collectible instance from a JSON object.
     * @param {any} json - JSON object containing the collectible data.
     * @returns {Collectible} A new Collectible instance.
     */
    static fromJson(json) {
        return new Collectible(Object.assign(Object.assign({}, json), { createdAt: json['created'] }));
    }
}
exports.Collectible = Collectible;
